import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerRotationListItem = (props) => {
    const { visualizerRotation, updateVisualizerSettings, maxRotation } = props;
    
    const onRotationChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ rotation: value });
    };
    
    return (
        <SliderListItem
            title='Rotation'
            value={visualizerRotation}
            displayMultiplier={1}
            min={0}
            max={maxRotation}
            step={1}
            onValueChange={onRotationChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { rotation: visualizerRotation } = state.createPreview.present.videoSettings.visualizer;
    const { maxRotation } = state.create.maxValues;

    return { 
        visualizerRotation,
        maxRotation
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerRotationListItem);